import { getRandomIntInclusive } from '@application/utils';
import { ContentPageContainer, ContentPageTitle, SkeletonBox } from '@presentation/components';
import { useCallback, useMemo } from 'react';
import * as RootStyled from '../../styled';
import * as Styled from './styled';

export const PageSkeleton = () => {
  const skeletons = useMemo(
    () => ({
      title: {
        width: `${getRandomIntInclusive(50, 60)}%`,
        height: 35,
        marginBottom: 10,
      },
      sections: Array(getRandomIntInclusive(5, 8))
        .fill(undefined)
        .map(() => ({
          title: { width: `${getRandomIntInclusive(50, 90)}%`, height: 35 },
          links: Array(getRandomIntInclusive(20, 40))
            .fill(undefined)
            .map(() => ({
              label: { width: `${getRandomIntInclusive(50, 70)}%`, height: 20 },
            })),
        })),
    }),
    [],
  );

  const skeletonSections = useCallback(() => {
    return skeletons.sections.map((section, key) => (
      <RootStyled.Section key={key}>
        <RootStyled.SectionTitle>
          <SkeletonBox style={skeletons.title} />
        </RootStyled.SectionTitle>
        <RootStyled.LinksContainer>
          {section.links.map((link, linkKey) => (
            <Styled.StyledLink key={linkKey}>
              <SkeletonBox style={link.label} />
            </Styled.StyledLink>
          ))}
        </RootStyled.LinksContainer>
      </RootStyled.Section>
    ));
  }, [skeletons]);

  return (
    <ContentPageContainer>
      <SkeletonBox style={skeletons.title} />
      <ContentPageTitle>
        <SkeletonBox style={skeletons.title} />
      </ContentPageTitle>
      {skeletonSections()}
    </ContentPageContainer>
  );
};
